(() => {
  const selector = '.template-product .coupon2-coupon-code';
  const codePattern = /^[A-Z0-9_-]{4,20}$/;

  const getCode = (element) => element.textContent.trim();

  const prepareCodes = (root = document) => {
    root.querySelectorAll(selector).forEach((element) => {
      const code = getCode(element);
      if (!codePattern.test(code)) return;

      element.classList.add('evelance-copy-code');
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.setAttribute('aria-label', `Copy offer code ${code}`);
      element.dataset.copyCode = code;
    });
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  };

  const copyCode = async (element) => {
    const code = element.dataset.copyCode;
    if (!code) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        fallbackCopy(code);
      }

      element.dataset.copyState = 'copied';
      element.setAttribute('aria-label', `${code} copied`);
      window.setTimeout(() => {
        element.dataset.copyState = '';
        element.setAttribute('aria-label', `Copy offer code ${code}`);
      }, 1800);
    } catch (error) {
      element.dataset.copyState = 'error';
    }
  };

  document.addEventListener('click', (event) => {
    const element = event.target.closest('.evelance-copy-code');
    if (element) copyCode(element);
  });

  document.addEventListener('keydown', (event) => {
    const element = event.target.closest('.evelance-copy-code');
    if (element && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      copyCode(element);
    }
  });

  document.addEventListener('DOMContentLoaded', () => prepareCodes());
  document.addEventListener('shopify:section:load', (event) => prepareCodes(event.target));
})();
